module.exports = __webpack_public_path__ + "media/telephone.3723a8f5.mp3";